import api from "./core";

const basePath = "api/core/Encounter";

export default {
  get(id, extraHeaders = null) {
    return api.get(`${basePath}/${id}`, extraHeaders);
  },
  query(filter, extraHeaders = null) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  queryImproved(filter, extraHeaders = null) {
    return api.post(`${basePath}/queryImproved`, filter, extraHeaders);
  },
  delete(id, extraHeaders = null) {
    return api.delete(`${basePath}/${id}`, extraHeaders);
  },
  update(id, data, extraHeaders = null) {
    return api.patch(`${basePath}/${id}`, data, extraHeaders);
  },
  submit(ids, extraHeaders = null) {
    return api.patch(`${basePath}/Submit`, ids, extraHeaders);
  },
  updateUb40Charge(id, data) {
    return api.put(`${basePath}/SubmitUB04Charge/${id}`, data);
  },
  getUb04Codes() {
    return api.get(`${basePath}/UB04Codes`);
  },
  getPatientBillingSummary(patientId) {
    return api.get(`${basePath}/Billing/${patientId}`);
  }
};
